import { OrderStatus, OrderType, ServiceType } from "./enums";
import { Dayjs } from "dayjs";

export class OrdersFilterRequest {
    pageIndex = 0;
    orderBy: string = "";
    orderAsc = false;
    keywords = "";
    fromDate: Dayjs | null = null;
    toDate: Dayjs | null = null;
    arrivalDateStart: string | null = null;
    arrivalDateEnd: string | null = null;
    departureDateStart: string | null = null;
    departureDateEnd: string | null = null;
    orderStatus: OrderStatus | null = null;
    orderType: OrderType | null = null;
    employeeStatus?: boolean | null = null;
    externalSystemId: number | null = null;
    employeeId: number | null = null;
    provider: string | null = null;
}

export class OrderSearchItem {
    id = 0;
    docket = "";
    externalSystem = "";
    status: OrderStatus = OrderStatus.None;
    type: OrderType = OrderType.WithoutSubsidy;
    total = 0;
    currencyId = 0;
    paidByWallet = 0;
    paidByEmployee = 0;
    subsidyAmount = 0;
    createdAt = "";
    updatedAt = "";
    employeeName = "";
    provider = "";
    employeePid = "";
    currencyRate = 0;
    currencyCode = "";
}

export interface OrdersFilterResponse {
    total: number;
    totalFilter: number;
    hasNext: boolean;
    orders: OrderSearchItem[];
}

export class OrderDetails {
    id = 0;
    docket = "";
    externalSystem = "";
    status: OrderStatus = OrderStatus.None;
    type: OrderType = OrderType.WithoutSubsidy;
    total = 0;
    currencyId = 0;
    paidByWallet = 0;
    paidByEmployee = 0;
    subsidyAmount = 0;
    createdAt = "";
    updatedAt = "";
    arrivalDate = "";
    departureDate = "";
    employeeName = "";
    employeeId = 0;
    employeeNumber = "";
    services: ServiceBase[] = [];
    subsidyAmountInShekel = 0;
    currencyCode = "";
    currencyRate = 0;
}

export class ServiceBase {
    serviceBaseId = 0;
    orderId = 0;
    serviceType: ServiceType = ServiceType.GeneralService;
    fromDate = "";
    toDate = "";
    providerName = "";
    providerCategoryName = "";
    numberAdults = 0;
    numberChilds = 0;
    numberInfants = 0;
    serviceNumber = 0;
    currencyId = 0;
    grossPrice = 0;
    totalPrice = 0;
}

export class HotelService extends ServiceBase {
    hotelName = "";
    roomTypeName = "";
    boardBaseName = "";
    regionName = "";
}

export class FlightService extends ServiceBase {
    name = "";
}

export class ExportOrdersResponse {
    interfaceId = 0;
    success = false;
}
